import type { ReactNode } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { useRouter } from 'next/router'
import { LocaleEnum } from 'shared/enums/locale-enum'
import useUser from 'shared/hooks/use-user'
import { useGetLoginUrl } from 'shared/utils/url-utils'
import PublicLanguageSwitcher from '../../public-language-switcher'
import { topMenuItems } from '../constants/top-menu-items'
import NavLink from './nav-link'

const DesktopMenu = (): ReactNode => {
  const router = useRouter()
  const locale = router.locale as LocaleEnum
  const { t } = useTranslation()
  const { user } = useUser()
  const loginUrl = useGetLoginUrl()

  return (
    <>
      <div className="hidden w-full items-center justify-between gap-5 lg:flex [&_a]:font-inter">
        <div className="flex w-full flex-wrap items-center justify-center gap-6">
          {topMenuItems
            .filter(item => !item.excludeLocales?.includes(locale))
            .map((item, index) => (
              <NavLink key={index} href={item.href}>
                {t(item.title)}
              </NavLink>
            ))}
        </div>
      </div>
      <div className="hidden basis-1/3 items-center justify-end gap-3 lg:flex [&_a]:font-inter">
        <div className="flex items-center gap-x-6 gap-y-3">
          <NavLink signInLink noLoco href={user ? '/dashboard' : loginUrl}>
            {user ? t('global.dashboard') : t('public.public_header.sing_in')}
          </NavLink>
        </div>
        <PublicLanguageSwitcher />
      </div>
    </>
  )
}

export default DesktopMenu
